import config from '../../../config'
import { Dropdown } from 'j-comps'
import CanvaIcon from './CanvaIcon'
import { connect } from 'react-redux'
import { createDesign } from '../../../data/actions'
import ContentSourcesLink from '../../../components/ContentSourcesLink'
import { getCanvaTypes } from '../../../utils/vendor'

const CanvaDropdown = ({ api, memberId, source, linkText }) => {
  const handleClick = async (typeObject) => {
    const design = typeObject?.isCustom
      ? {
          dimensions: {
            height: typeObject.value.height,
            width: typeObject.value.width,
          },
        }
      : { type: typeObject.name }

    if (api) {
      api.createDesign({
        editor: { publishLabel: 'Save' },
        design,
        onDesignPublish: ({ exportUrl, designId }) => {
          createDesign(exportUrl, designId, memberId)
          // Triggered when design is published to an image.
          // Save the image to your server as the exportUrl will expire shortly.
        },
      })
    }
  }

  const canvaTypes = getCanvaTypes()

  const middleItems = canvaTypes.map((typeObject) => {
    return {
      text: typeObject.name,
      onClick: () => handleClick(typeObject),
    }
  })

  const CanvaButton = () => (
    <Dropdown
      appName={config.app}
      firstItem={{ text: 'Design Type' }}
      middleItems={middleItems}
      dropdownButton={{
        icon: <CanvaIcon />,
      }}
    />
  )

  return source === 'stream' ? (
    <ContentSourcesLink linkText={linkText} />
  ) : (
    <CanvaButton />
  )
}

const mapStateToProps = (state) => ({
  api: state.api,
  memberId: state.memberId,
  source: state.source,
})

export default connect(mapStateToProps)(CanvaDropdown)
